window._ = require('lodash');

try {

  /**
   * We'll load jQuery and the Bootstrap jQuery plugin which provides support
   * for JavaScript based Bootstrap features such as modals and tabs.
   */
  window.$ = window.jQuery = require('jquery');

  require('bootstrap-sass');

  /**
   * We'll load AdminLTE JS function and its plugins
   */
  require('admin-lte'); // adminlte
  require('pace-progress'); // pace
  require('jquery-slimscroll'); // slimscroll
  require('fastclick'); // fastclick
  require('bootstrap-datepicker'); // bootstrap timepicker
  require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.fr.min'); // bootstrap
                                                                            // datepicker
                                                                            // fr
  require('bootstrap-timepicker'); // bootstrap timepicker
  require('bootstrap-colorpicker'); // bootsrap colorpicker
  require('icheck'); // icheck
  require('select2'); // select2
  require('daterangepicker'); // bootstrap date range picker
  window.Handlebars = require('handlebars'); // handlebars

  // pour generer les bilans pdf
  window.jsPDF = require('jspdf'); // jsPDF
  window.html2pdf = require('html2pdf.js'); // html2pdf

  // datatable
  window.dt = require('datatables.net');
  require('datatables.net-bs');
  require('datatables.net-responsive');
  require('datatables.net-responsive-bs');

  // bootbox
  window.bootbox = require('bootbox');

  // moment
  window.moment = require('moment');
  require('moment/locale/fr');

  // highcharts
  window.Highcharts = require('highcharts/highstock');
  require('highcharts/modules/exporting')(Highcharts);
  require('highcharts/modules/export-data')(Highcharts);
  require('highcharts/modules/no-data-to-display')(Highcharts);

  // polyfill matchmedia
  require('matchmedia-polyfill');
}
catch (e) {
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}
else {
  console.error(
      'CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */
window.Pusher = require('pusher-js');

import Echo from 'laravel-echo';

window.Echo = new Echo({
  broadcaster: 'pusher',
  key:         '995bffa0e74166fd6a3b',
  encrypted:   true,
  namespace:   'Aqualis.Events',
  cluster:     'eu'
});

/**
 * Configuration générale pour les construction des graphes.
 */
import moment from 'moment';

Highcharts.setOptions({
  credits: {
    enabled: false
  },
  global:  {
    timezoneOffset: moment().utcOffset(),
    useUTC:         false
  }
});



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js